"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeParseExtendedGraphQlError = exports.safeParseExtendedApolloError = exports.parseExtendedGraphQlError = exports.parseExtendedApolloError = void 0;
const zod_1 = require("zod");
/// HELPER FUNCTIONS
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const makeApolloErrorSchema = (errorSchema) => {
    const GraphQlErrorSchema = makeGraphQlErrorSchema(errorSchema);
    return zod_1.z.object({
        graphQLErrors: zod_1.z.array(GraphQlErrorSchema),
    });
};
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const makeGraphQlErrorSchema = (errorSchema) => zod_1.z.object({
    message: zod_1.z.string().min(1),
    extensions: zod_1.z.object({
        code: zod_1.z.string().min(1),
        errors: zod_1.z.array(errorSchema),
    }),
});
/// PARSING FUNCTIONS
const parseExtendedApolloError = (error, errorSchema) => {
    const ApolloErrorSchema = makeApolloErrorSchema(errorSchema);
    return ApolloErrorSchema.parse(error);
};
exports.parseExtendedApolloError = parseExtendedApolloError;
const parseExtendedGraphQlError = (error, errorSchema) => {
    const GraphQlErrorSchema = makeGraphQlErrorSchema(errorSchema);
    return GraphQlErrorSchema.parse(error);
};
exports.parseExtendedGraphQlError = parseExtendedGraphQlError;
const safeParseExtendedApolloError = (error, errorSchema) => {
    const ApolloErrorSchema = makeApolloErrorSchema(errorSchema);
    return ApolloErrorSchema.safeParse(error);
};
exports.safeParseExtendedApolloError = safeParseExtendedApolloError;
const safeParseExtendedGraphQlError = (error, errorSchema) => {
    const GraphQlErrorSchema = makeGraphQlErrorSchema(errorSchema);
    return GraphQlErrorSchema.safeParse(error);
};
exports.safeParseExtendedGraphQlError = safeParseExtendedGraphQlError;
